import { combineReducers } from "redux";
import {
  ACTION_SET_BOOKS,
  ACTION_DELETE_BOOK,
  ACTION_SET_EDITOR_BOOK_ID,
  ACTION_SET_USER_INFO,
  ACTION_SET_UPLOAD_FILE,
  ACTION_CLEAR_UPLOAD_FILE,
} from "./actions";
import AnalysisArticle from "pages/analysis-article/reducer";
import CreateBookName from "pages/create-book-name/reducer";
import EditorBook from "pages/editor-book/reducer";
import PreviewWords from "pages/preview-words/reducer";
import Confirm from "components/confirm/reducer";

const reducers = combineReducers({
  ...AnalysisArticle,
  ...CreateBookName,
  ...EditorBook,
  ...PreviewWords,
  ...Confirm,
  user_info(state = {}, action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_USER_INFO:
        return payload;
    }
    return state;
  },
  books(state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_BOOKS:
        return payload;
      case ACTION_DELETE_BOOK:
        const new_state = state.slice();
        new_state.splice(payload, 1);
        return new_state;
    }
    return state;
  },
  editor_book_id(state = "", action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_EDITOR_BOOK_ID:
        return payload;
    }
    return state;
  },
  upload_file(state = null, action) {
    const { type, payload } = action;
    switch (type) {
      case ACTION_SET_UPLOAD_FILE:
        return payload;
      case ACTION_CLEAR_UPLOAD_FILE:
        return null;
    }
    return state;
  },
});
export default reducers;
